import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SearchGroupList } from "../../../model/branch/BranchGroupsModel";

interface ModalInterface {
  timestamp: number;
  detailGroup: SearchGroupList | null;
}

const initialState: ModalInterface = {
  timestamp: Date.now(),
  detailGroup: null,
};

const detailConnectGroupSlice = createSlice({
  name: "detailconnectgroup",
  initialState,
  reducers: {
    updateTimestamp: (state) => {
      state.timestamp = Date.now();
    },
    updateGroup: (state, action: PayloadAction<SearchGroupList>) => {
      state.detailGroup = action.payload;
    },
  },
});

export const { updateGroup } = detailConnectGroupSlice.actions;

export default detailConnectGroupSlice.reducer;
